<template>
    <div class="white pa-4">
        <Block v-if="loading" />
        <v-row class="wrapper">
            <v-col cols="12" md="5">
                <v-autocomplete v-model="provider" :items="providersList" label="Proveedor" item-text="name"
                    item-value="value" outlined dense attach @change="getData()" />
            </v-col>
            <v-col cols="12" md="3">
                <date-picker label="A la fecha de" @dateSelected="getData" />
            </v-col>
            <v-col cols="12" md="4" class="d-flex justify-end">
                <v-btn class="btn-save" @click="setupPrint">
                    <v-icon>mdi-printer</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <!-- <v-row class="wrapper-filter"> -->
        <!-- <VersatileFilter :columnsSearch="columsConfig" :search="search" @emptyFilter="getData"
            @filtered="filterHandler" :key="Reloadfilter" :hideSearchField="true"
            :columnfilterEndpoint="getData" oneDateFilter @getOneDate="setSelectedDate"> -->
            <DxDataGrid :dataSource="DataTable" :columns="columnsList" @exporting="onExporting"
                :word-wrap-enabled="true" :scrolling="{ useNative: true }" :column-auto-width="true">
                <DxExport :enabled="true" />
                <DxPager :showPageSizeSelector="true" :allowedPageSizes="[10, 30, 50]" />
                <DxPaging :page-size="10" />
            </DxDataGrid>
        <!-- </VersatileFilter> -->
        <!-- </v-row> -->

        <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert" />
        <div>
            <component v-for="(item, index) in PrintList" :key="index" :is="item.component" v-bind="item.props" />
        </div>
    </div>
</template>

<script>

//import {mapState} from 'vuex';
import VersatileFilter from '@/components/VersatileFilter.vue';
import { DxDataGrid, DxPager, DxPaging, DxExport } from 'devextreme-vue/data-grid';
import DatePicker from '@/components/DatePicker'
import Block from '@/components/Block.vue';
import Alerts from '@/components/Alerts.vue';
import { printToExcel } from "@/helpers/printToexcel";
import { numberWithCommas } from '@/helpers/money';
import PrintAccountsPayableStatement from '../../../components/ReportsAndPrintings/SalesReports/PrintAccountsPayableStatement.vue';

export default {
    name: "CustomersAccountsPayable",
    components: {
        DxDataGrid,
        DxPager,
        DxPaging,
        Block,
        Alerts,
        DxExport,
        VersatileFilter,
        PrintAccountsPayableStatement,
        DatePicker,
    },
    props: ['win'],
    data() {
        return {
            PrintList: [],
            print: {
                show: false,
                header: {
                },
                data: [],
            },
            // Customers: [],
            DataTable: [],
            panel: 0,
            tab: null,
            key: 0,
            loading: false,
            alert: {
                type: "success",
                show: false,
                header: "",
                body: "",
            },
            ClientList: [],
            ExpiredAccountsSellerList: [],
            requestDate: null,
            columnsList: [
                { dataField: "ID_PurchaseLegalInvoiceNumber", caption: "Código generación" },
                { dataField: "ID_PurchaseOrder", caption: "No. Documento" },
                { dataField: "ProviderLegalName" , caption: "Nombre Legal" },
                { dataField: "PurchaseInvoiceDate", caption: "Fecha de la Factura" },
                { dataField: "fecha_vencimiento", caption: "Fecha de Pago" },
                { dataField: "total", caption: "Total" },
                { dataField: "abonado", caption: "Abonado" },
                { dataField: "saldo", caption: "Saldo" },
                { dataField: "saldo_30", caption: "Saldo de 30 días" },
                { dataField: "saldo_60", caption: "Saldo de 60 días" },
                { dataField: "saldo_90", caption: "Saldo de 90 días" },
                { dataField: "saldo_120", caption: "Saldo de 120 días" },
                { dataField: "saldo_mas_120", caption: "Saldo de mas de 120 días" },
            ],
            columsConfig: [],
            Currency: JSON.parse(localStorage.getItem('branch')).Currency || "",
            idbusiness: JSON.parse(localStorage.getItem("user")).businessid || "",
            idbranch: JSON.parse(localStorage.getItem("user")).branch || "",
            search: {},
            dates: {},
            useDate : false,
            Reloadfilter: 0,
            providersList: [],
        }
    },
    watch: {
        envType() {
            this.getData();
        }
    },  
    computed: {

    },
    async mounted() {
        const date = new Date()
        this.requestDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate()}`;
        await this.getAllProviders();
        this.getData();
    },
    methods: {
        onExporting(e) {
            printToExcel(e, `Reporte de cuentas por pagar`);
        },
        async getAllProviders() {
            await this.$API.providers.getProviders()
                .then((res) => {
                    console.log('res', res);
                    // this.providersList = res.data;
                    console.log('this.providersList', this.providersList);
                    const providers = res.map((provider) => ({
                        name: provider.ProviderLegalName,
                        value: provider.ID_Provider,
                        // address: customer.Address
                    }));
                    if (providers.length > 0) {
                        this.providersList.push({ name: "Sin Proveedor Asignado", value: '' });
                        this.providersList.push({ name: "Ver Todos Los Proveedores Asignados", value: 'ALL' });
                        this.providersList.push(...providers);
                        this.provider = this.providersList[0].value;
                        this.search.ID_Provider = this.provider;
                    }
                })
                .catch((error) => {
                    console.log(error)
                });
        },
        filterHandler(data) {
            if (data.length > 0) {
                this.DataTable = data.map(item => {
                    return item
                });
                return;
            }
            this.DataTable = [];
        },
        handleNumber(value) {
            return value ? numberWithCommas(value) : 0.00;
        },
        formatTable() {
            this.DataTable.map((data) => {
                data.total = this.handleNumber(data.total);
                data.abonado = this.handleNumber(data.abonado);
                data.saldo = this.handleNumber(data.saldo);
                data.saldo_30 = this.handleNumber(data.saldo_30);
                data.saldo_60 = this.handleNumber(data.saldo_60);
                data.saldo_90 = this.handleNumber(data.saldo_90);
                data.saldo_120 = this.handleNumber(data.saldo_120);
                data.saldo_mas_120 = this.handleNumber(data.saldo_mas_120);
            })
        },
        setSelectedDate(e) {
            this.requestDate = e;
        },
        async getData(find) {
            try {
                this.loading = true;
                this.search.ID_Provider = this.provider;

                if(this.provider === this.providersList[0].value) {
                    this.DataTable = [];
                    // this.Reloadfilter++;
                    return;
                }

                let response = await this.$API.providers.getProviderAccountStatement({
                    extraParam1: this.extraParam1, 
                    filter : find?.filter ?? JSON.stringify([]),
                    business: this.search.business,
                    branch: this.search.branch,
                    search: JSON.stringify(this.search),
                    like: find?.like,
                    selectedItem: this.radioSelect != [] ? this.selectedItem : null,
                    requestDate: this.requestDate,
                    hideNoStockRecords: this.oNoStockRecords,
                    envType: this.search.envType,
                });
                if (response.length > 0) {
                    this.DataTable = response;
                    this.formatTable();
                }
                else {
                    this.DataTable = [];
                }
            } catch (error) {
                console.error(error)
                this.showAlert('danger', 'Error', error.response.data.message);
            } finally {
                this.loading = false;
            }
        },
        closeAlert() {
            this.alert.show = false;
        },
        acceptAlert() {
            this.alert.show = false;
        },
        showAlert(type, header, body, options = null) {
            type = type == null ? "danger" : type;
            this.alert.type = type;
            this.alert.header = header;
            this.alert.body = body;
            this.alert.show = true;
            this.alert.options = options != null ? options : null;
        },
        async setupPrint() {
            this.print.data.body = this.DataTable;
            this.print.header.title = "Estado de cuentas";
            const { businessid = "", } = JSON.parse(localStorage.getItem("user"));
            this.business = await this.$API.business.FindOne(businessid)
            // this.print.header.title = "Resumen de cuentas por cobrar";
            
            const date = new Date();

            this.print.header.business = this.business;
            //date wiht format dd/mm/yyyy
            this.print.header.cutDate = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
            
            this.print.show = true;

            this.PrintList.push({
                component: PrintAccountsPayableStatement, props: {
                    dataProps: this.print,
                }
            });
        },
    },

}
</script>

<style scoped>
.bar {
    width: 100%;
    background-color: rgb(60, 60, 60) !important;
    color: white !important;
    border-style: solid;
    border-color: black;
    border-radius: 15px !important;
    margin-top: 1rem !important;
}

.btn-add {
    background-color: #3498DB !important;
    color: white;
}

.btnsave {
    background-color: #00A178 !important;
    color: white;
}

.btnclean {
    background-color: #F29D35 !important;
    color: white;
}

.btndelete {
    background-color: #E3191E !important;
    color: white;
}
.wrapper {
    align-items: start;
}
.wrapper-filter:deep(.row.mt-4.d-flex ) {
    /* justify-content: end; */
    /* align-items: center; */
}
</style>